import defaultIcon from '../imgs/default.svg';
import completedIcon from '../imgs/icon-completed.svg';
import proxyEstablishedNoIcon from '../imgs/proxy-established-no.svg';
import proxyEstablishedYesIcon from '../imgs/proxy-established-yes.svg';
import selfEstablishedNoIcon from '../imgs/self-established-no.svg';
import selfEstablishedYesIcon from '../imgs/self-established-yes.svg';
import iconError from '../imgs/icon-error.svg';
import { pages } from '../../constants/routes';

const DEFAULT_ICON = {
  path: defaultIcon,
  altText: "A light gray circle with a darker gray silhouette."
};
const COMPLETED_ICON = {
  path: completedIcon,
  altText: "Green circle with a white checkmark."
};
const PROXY_ESTABLISHED_NO_ICON = {
  path: proxyEstablishedNoIcon,
  altText: "Abstracted illustration of a male and a female within a light blue circle."
};
const PROXY_ESTABLISHED_YES_ICON = {
  path: proxyEstablishedYesIcon,
  altText: "Abstracted illustration of a male and a female within a light blue circle, with a Cleveland Clinic logo in the lower right corner."
};
const SELF_ESTABLISHED_NO_ICON = {
  path: selfEstablishedNoIcon,
  altText: "Abstracted illustration of a male within the light blue circle."
};
const SELF_ESTABLISHED_YES_ICON = {
  path: selfEstablishedYesIcon,
  altText: "Abstracted illustration of a male within the light blue circle, with a Cleveland Clinic logo in the lower right corner."
};
const ERROR_ICON = {
  path: iconError,
  altText: "Red circle with a white explanation mark."
};
const ORDER_OF_PAGES = [
  [ pages.WHAT_TO_EXPECT ],
  [ pages.WHO_FOR ],
  [ pages.RECEIVED_CARE ],
  [ pages.CONTACT_INFO ],
  [ pages.NEW_PATIENT_INFO, pages.EXISTING_PATIENT_INFO ],
  [ pages.NEW_PATIENT_ADDRESS ],
  [ pages.APPOINTMENT_INFO1 ],
  [ pages.APPOINTMENT_INFO2 ],
  [ pages.APPOINTMENT_PREFERENCES ],
  [ pages.APPOINTMENT_INFO_PROVIDER ],
  [ pages.APPOINTMENT_INFO_DAY_TIME ],
  [ pages.PAYMENT_METHOD ],
  [ pages.INSURANCE ],
  [ pages.POLICY_HOLDER, pages.OUT_OF_POCKET ],
  [ pages.BILLING ],
  [ pages.BILLING_ADDRESS ],
  [ pages.REVIEW ],
  [ pages.ERROR_REVIEW ],
  [ pages.PFA_APPOINTMENT ],
  [ pages.THANK_YOU_PFA_APPT, pages.THANK_YOU_PFA, pages.THANK_YOU_INSURANCE ],
];

export function determineProgress (pageName) {
  let stepNumber = 1;

  if (pageName === pages.ERROR_REVIEW) {
    stepNumber = ORDER_OF_PAGES.length; // If error occurred during review, set stepNumber to the error review page
  } 
  else {
    for (let [index, pageStep] of ORDER_OF_PAGES.entries()) {
      if (pageStep.includes(pageName)) {
        stepNumber = index + 1;
        break;
      }
    }
  }
  return stepNumber;
}

export function determineIcon(pageName, state = {}) {
  let forMe = state.forMe;
  let patientSeenRecently = state.patientSeenRecently;
  let dataHasBeenCleared = !state.acknowledgedWhatToExpect;

  switch (pageName) {
    case pages.WHAT_TO_EXPECT:
    case pages.WHO_FOR:
      return DEFAULT_ICON;
    case pages.RECEIVED_CARE:
    case pages.CONTACT_INFO:
    case pages.NEW_PATIENT_INFO:
    case pages.EXISTING_PATIENT_INFO:
    case pages.NEW_PATIENT_ADDRESS:
    case pages.APPOINTMENT_INFO1:
    case pages.APPOINTMENT_INFO2:
    case pages.APPOINTMENT_PREFERENCES:
    case pages.APPOINTMENT_INFO_PROVIDER:
    case pages.APPOINTMENT_INFO_DAY_TIME:
    case pages.PAYMENT_METHOD:
    case pages.INSURANCE:
    case pages.POLICY_HOLDER:
    case pages.OUT_OF_POCKET:
    case pages.BILLING:
    case pages.BILLING_ADDRESS:
    case pages.REVIEW:
      if (dataHasBeenCleared) {
        return DEFAULT_ICON;
      }
    case pages.PFA_APPOINTMENT:
      return forMe ? (patientSeenRecently ? SELF_ESTABLISHED_YES_ICON : SELF_ESTABLISHED_NO_ICON) : (patientSeenRecently ? PROXY_ESTABLISHED_YES_ICON : PROXY_ESTABLISHED_NO_ICON);
    case pages.THANK_YOU_PFA_APPT:
    case pages.THANK_YOU_PFA:
    case pages.THANK_YOU_INSURANCE:
      return COMPLETED_ICON;
    case pages.ERROR_REVIEW:
      return ERROR_ICON;
    default:
      return DEFAULT_ICON; 
  }
}